import { FormActionPayload, SubmitCallback } from './types'

export const createFormActionPayload = <T extends object>(values: object, complete: SubmitCallback | undefined) =>
  ({
    values,
    complete,
  } as FormActionPayload<T>)

export function generateFormData<T>(data: T): FormData {
  const formData = new FormData()
  const keys = Object.keys(data)

  keys.map((key) => {
    formData.append(key, data[key])
  })

  return formData
}



// WEBPACK FOOTER //
// ./src/modules/forms/helpers.ts